import { PressableVariants } from '@unistocks/components/basic/variants';
import { H3 } from '@unistocks/components/text/text';
import {
  GetProps,
  CardBackground as TMCardBackground,
  CardFooter as TMCardFooter,
  CardFrame as TMCardFrame,
  CardHeader as TMCardHeader,
  ThemeableStack,
  styled,
  themeableVariants,
  withStaticProperties
} from 'tamagui';

export type CardProps = GetProps<typeof CardFrame>;
export type CardHeaderProps = GetProps<typeof CardHeader>;
export type CardHeadingProps = GetProps<typeof CardHeading>;
export type CardBodyProps = GetProps<typeof CardBody>;

const CardFrame = styled(TMCardFrame, {
  overflow: 'visible',

  variants: {
    ...PressableVariants,
    bordered: themeableVariants.bordered,
    elevate: themeableVariants.elevate
  },

  defaultVariants: {
    pressable: false,
    hoverable: false
  }
});

const CardHeader = styled(TMCardHeader, {
  name: 'CardHeader',
  padding: '$true',
  pb: 0,
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
});

const CardHeading = styled(H3, {
  name: 'CardHeading',
  color: '$headingFont',
  userSelect: 'none'
});

const CardBody = styled(ThemeableStack, {
  name: 'CardBody',
  padding: '$true',
  display: 'flex',
  flexDirection: 'column',
  gap: '$2'
});

export const Card = withStaticProperties(CardFrame, {
  Background: TMCardBackground,
  Header: CardHeader,
  Heading: CardHeading,
  Body: CardBody,
  Footer: TMCardFooter
});
